export default __webpack_public_path__ + "static/media/audit_1.57a4a31c.jpg";